import Vue from 'vue'
import Router from 'vue-router'
import {isMobile } from '@/../store/store';


const web = (name) => () => import(`@/views/web/${name}`);
const mobile = (name) => () => import(`@/views/mobile/${name}`);
const both = isMobile() ? mobile : web;

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
var routes = [{
		path: '/',
		name: '',
		component: both("Home"),
		children: [{
				path: '',
				component: both("teachers/member"),
				name: '个人中心'
			},
			{
				path: 'login',
				component: both("login"),
				name: '登录'
			},
			{
				path: 'teachers_courses',
				component: both("teachers/courses"),
				name: '常规课'
			},
			{
				path: 'teachers_camp',
				component: both("teachers/camp"),
				name: '夏令营'
			},
			{
				path: 'teachers_information',
				component: both("teachers/information"),
				name: '资讯中心'
			},
			{
				path: 'member_information_info',
				component: both("teachers/information_info"),
				name: '资讯中心详情'
			},
			{
				path: 'working_time',
				component: both("teachers/working_time"),
				name: '工时统计'
			},
			{
				path: 'account',
				component: both("teachers/account"),
				name: '修改密码'
			},
			{
				path: 'virtual_index',
				component: both("virtual/index"),
				name: '老师虚拟班'
			},
			{
				path: 'virtual_staytask',
				component: both("virtual/staytask"),
				name: '老师虚拟班留作业'
			},
			{
				path: 'virtual_batchtask',
				component: both("virtual/batchtask"),
				name: '老师虚拟班批作业'
			},
			{
				path: 'virtual_batchtask_info',
				component: both("virtual/batchtask_info"),
				name: '老师虚拟班批作业详情'
			},
			{
				path: 'virtual_parent',
				component: both("virtual/parent"),
				name: '老师虚拟班家长'
			},
			{
				path: 'virtual_letter',
				component: both("virtual/letter"),
				name: '老师虚拟班信'
			},
			{
				path: 'virtual_debate',
				component: both("virtual/debate"),
				name: '老师虚拟班辩论评估'
			},
			{
				path: 'virtual_assess',
				component: both("virtual/assess"),
				name: '老师虚拟班评估'
			},
			{
				path: 'virtual_assessinfo',
				component: both("virtual/assessinfo"),
				name: '老师虚拟班评估详情'
			},
			{
				path: 'virtual_assess_history',
				component: both("virtual/assess_history"),
				name: '老师虚拟班评估历史'
			},
			{
				path: 'virtual_certificate',
				component: both("virtual/certificate"),
				name: '老师虚拟班证书'
			},
			{
				path: 'virtual_leave',
				component: both("virtual/leave"),
				name: '老师虚拟班请假'
			},
			{
				path: 'virtual_student',
				component: both("virtual/student"),
				name: '学生列表'
			},
			{
				path: 'private_classes',
				component: both("teachers/private_classes"),
				name: '私教课'
			},
			{
				path: 'availability',
				component: both("teachers/availability"),
				name: '空闲时间'
			},
			{
				path: 'teachers_private',
				component: both("teachers/private"),
				name: '我的私教课'
			},
			{
				path: 'private_index',
				component: both("private/index"),
				name: '私教课的虚拟班级'
			},
			{
				path: 'private_parent',
				component: both("private/parent"),
				name: '私教课的虚拟班级批家长交流'
			},
		],
	},
];
Vue.prototype.routes_data = routes;
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js